import React from "react";
import { useTranslation } from "react-i18next";
import { Stack, TextField, Typography } from "@mui/material";

const TargetClearCountField = ({
  targetClearCount,
  setTargetClearCount,
}: {
  targetClearCount: number;
  setTargetClearCount: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <TextField
        type="number"
        size="small"
        value={targetClearCount}
        onChange={(e) => setTargetClearCount(Number(e.target.value))}
        inputProps={{ min: 1 }}
        sx={{ width: 150 }}
      />
      <Typography color="primary">
        {t(
          "quest_edit_target.field.target_clear_count.target_clear_count.label",
        )}
      </Typography>
    </Stack>
  );
};

export default TargetClearCountField;
